import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbCarousel, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef } from 'ngx-bootstrap';
import { DlpService } from 'src/app/service/dlp.service';
import { PricingService } from 'src/app/service/pricing.service';

@Component({
  selector: 'app-advance-mortgage-calculator',
  templateUrl: './advance-mortgage-calculator.component.html',
  styleUrls: ['./advance-mortgage-calculator.component.scss']
})
export class AdvanceMortgageCalculatorComponent implements OnInit {
  @Input() refId = "67b9b98bce8ad00001e43b9a";
  @Input() criteriaList = [];
  @Input() scenarios = [];
  @Input() companyId = '';

  interestRate = 6.5;
  homePrice: number = 350000;
  downPayment: number = 70000;
  rateList = [];
  ficoScore = 'excellent';
  loanTerm = '30';
  loanType = 'conventional';
  monthlyPayment: number = 0;
  hoaDuesValue: number = 0;
  homeInsuranceRate: number = 0.45;
  propertyTaxAmount: number;
  homeInsuranceAmount: number = this.homePrice * this.homeInsuranceRate / 100 / 12;
  apr: number = 6.947;
  chunkedRates: any[][] = [];
  emailScenario = false;
  emailDetails = {};
  selectedRate: any;
  contact = {
    propertyAddress: {
      state: '',
      street: '',
      streetCont: '',
      city: '',
      zip: '',

    },
    firstname: '',
    lastname: '',
    email: '',
    phone: ''
  };

  public doughnutChartData: number[] = [];
  constructor(public bsModalRefParam: BsModalRef,
    private pricingService: PricingService,
    private dlpService: DlpService,
    config: NgbCarouselConfig,
  ) {
    this.propertyTaxAmount = this.calculatePropertyTaxAmount();
    config.showNavigationArrows = false;
    config.showNavigationIndicators = false;
  }

  get homePriceValue() {
    return this.homePrice;
  }

  get downPaymentValue() {
    return this.downPayment;
  }

  get legends() {
    return [
      { label: 'Principal & Interest', color: '#00BCD5', value: this.monthlyPayment },
      { label: 'Home Insurance', color: '#FF9801', value: this.homeInsuranceAmount },
      { label: 'Property Tax', color: '#FFC208', value: this.propertyTaxAmount },
      { label: 'HOA Fees', color: '#3F51B5', value: this.hoaDuesValue }];
  }

  calculatePropertyTaxAmount() {
    return Math.round(this.homePrice * 0.9 / 100 / 12);
  }

  ngOnInit() {
    this.calculateMortgage();
    this.updateChartData();
    this.rateList = this.criteriaList[0];
    this.chunkRates();
    this.loanType = this.scenarios[0].name;
    this.applyRate(this.rateList[0]);
  }

  closeModal() {
    this.bsModalRefParam.hide();
  }

  get downPaymentPercentage(): number {
    return (this.downPayment / this.homePrice) * 100;
  }

  get monthlyPaymentTotal() {
    return this.monthlyPayment + this.homeInsuranceAmount + this.propertyTaxAmount + this.hoaDuesValue;
  }

  setDownPaymentPercentage(percentage: number) {
    this.downPayment = (percentage / 100) * this.homePrice;
  }

  downPayPercentage() { 
    return (+this.downPayment / +this.homePrice) * 100 || 0;
  }

  updateHomePrice(event: any) {
    const prevPercentage = this.downPayPercentage();
    this.homePrice = +event;
    this.downPayment = Math.round(+prevPercentage * +this.homePrice / 100);
    this.propertyTaxAmount = this.calculatePropertyTaxAmount();
    this.calculateMortgage();
    this.updateChartData();
  }

  updateDownPayment(event: any) {
    this.downPayment = +event;
    this.calculateMortgage();
    this.updateChartData();
  }

  calculateMortgage() {
    const loanAmount = this.homePrice - this.downPayment;
    const monthlyInterestRate = this.interestRate / 100 / 12;
    const numberOfPayments = +this.loanTerm * 12; // 30 years mortgage
    this.monthlyPayment = (loanAmount * monthlyInterestRate) / (1 - Math.pow(1 + monthlyInterestRate, -numberOfPayments));
  }

  updateChartData() {
    this.doughnutChartData = [
      Math.round(this.monthlyPayment),
      Math.round(this.homeInsuranceAmount),
      Math.round(this.propertyTaxAmount),
      this.hoaDuesValue
    ];
  }

  applyRate(rateData) {
    this.interestRate = rateData.adjustedRates;
    this.loanTerm = rateData.term;
    this.apr = rateData.apr;
    this.selectedRate = rateData;
    this.calculateMortgage();
    this.updateChartData();
  }


  searchRates() {
    this.pricingService.getSearch(this.refId).toPromise()
      .then(ref => {
        console.log(ref);
        this.scenarios = ref.miniPricerPref.search.loanCriterias;
        this.getRateList(ref);
        // this.loading = false;
      })
      .catch(err => {
        // this.loading = false;
        console.error(err);
      });
  }

  onScenarioChange(e) {
    const scenarioIndex = this.scenarios.findIndex((criteria) => criteria.name === e);
    this.rateList = this.criteriaList[scenarioIndex];
    this.chunkedRates = [];
    this.chunkRates();
  }


  getRateList(payload?: any) {
    this.pricingService.search(payload).toPromise()
      .then(data => {
        this.criteriaList = data;
        this.rateList = data[0];
        this.chunkRates();
      })
      .catch(err => {
        console.error(err);
      });
  }

  chunkRates() {
    const chunkSize = 3;
    for (let i = 0; i < this.rateList.length; i += chunkSize) {
      this.chunkedRates.push(this.rateList.slice(i, i + chunkSize));
    }
  }

  onSlideRangeChange(event) {
  }

  onEmailScenario() {
    if (this.emailScenario) {
      this.sendEmail();
    } else {
      this.emailScenario = !this.emailScenario;
    }
  }

  onViewCalculator() {
    this.emailScenario = false;
  }

  isRateSelected(rate: any): boolean {
    return this.selectedRate === rate;
  }

  sendEmail() {
    const emailDetails = {
      templateId: '67c0a06ba21322126d56b7ca',
      contacts: [{
        name: this.contact.firstname + ' ' + this.contact.lastname,
        email: this.contact.email
      }],
      map: {
        'propertyAddress.state': this.contact.propertyAddress.state,
        'propertyAddress.street': this.contact.propertyAddress.street,
        'propertyAddress.streetCont': this.contact.propertyAddress.streetCont,
        'propertyAddress.city': this.contact.propertyAddress.city,
        'propertyAddress.zip': this.contact.propertyAddress.zip,
        'firstname': this.contact.firstname,
        'lastname': this.contact.lastname,
        'email': this.contact.email,
        'phone': this.contact.phone,
        'homePrice': this.homePrice,
        'loanAmount': this.homePrice - this.downPayment,
        'downPayment': this.downPayment,
        'downPaymentPercentage': this.downPaymentPercentage,
        'interestRate': this.interestRate,
        'loanTerm': this.loanTerm,
        'loanScenario': this.loanType,
        'monthlyPayment': this.monthlyPayment,
        'homeInsuranceAmount': this.homeInsuranceAmount,
        'propertyTaxAmount': this.propertyTaxAmount,
        'apr': this.apr,
        'propertyTaxRate': this.propertyTaxAmount / (this.homePriceValue / 12) * 100,
        'hoaDuesValue': this.hoaDuesValue,
        'monthlyPaymentTotal': this.monthlyPaymentTotal,
        'ficoScore': this.ficoScore
      },
      attachments: [],
      contactsBcc: [{
        name: this.contact.firstname + ' ' + this.contact.lastname,
        email: this.contact.email
      }],
    }
    this.dlpService.sendMortgageEmail('5d64369769515b0001964707', [emailDetails]).toPromise()
      .then(data => {
        console.log(data);
      }).catch(err => {
        console.error(err);
      })
  }

}
